import { render, staticRenderFns } from "./ViewsTable.vue?vue&type=template&id=55886b7e&"
import script from "./ViewsTable.vue?vue&type=script&lang=ts&"
export * from "./ViewsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports